angular.module('AccountingBoxApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/account/login/login.html',
                controller: 'LoginCtrl'
            })
            .state('signup', {
                url: '/registreren',
                templateUrl: 'app/account/signup/signup.html',
                controller: 'SignupCtrl',
                authenticate: false
            })
            .state('password', {
                url: '/wachtwoord?access_token',
                templateUrl: 'app/account/password/password.html',
                controller: 'PasswordCtrl'
            })
            .state('reset', {
                url: '/wachtwoord/resetten',
                templateUrl: 'app/account/password/password.html',
                controller: 'PasswordCtrl'
            })
    });
